import { render } from "./UnitAdministration.vue?vue&type=template&id=31129d82&scoped=true"
import script from "./UnitAdministration.vue?vue&type=script&lang=js"
export * from "./UnitAdministration.vue?vue&type=script&lang=js"

import "./UnitAdministration.vue?vue&type=style&index=0&id=31129d82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31129d82"]])

export default __exports__